import { Stack } from "expo-router";

export default function ComplianceLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
